import styled from 'styled-components';
import { List } from '../styled.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var CollapsibleContent = styled.div.withConfig({
  displayName: "CollapsibleContent",
  componentId: "sc-11oijrn-0"
})(["display:", ";margin-left:", ";overflow:hidden;", "{padding:0;min-width:auto;}"], function (props) {
  return props.$open ? 'block' : 'none';
}, themeGet('spacing.2xl'), List);
var IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-11oijrn-1"
})(["display:flex;align-items:center;justify-content:center;margin-left:auto;[data-icon='falcon']{color:", ";width:", ";}"], themeGet('colors.gray.500'), pxToRem(12));

export { CollapsibleContent, IconContainer };
